import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getUserLists } from '../data/mock';

// Hook to track user behavior and trigger smart login prompts
export const useConversionTracking = () => {
  const { isAuthenticated } = useAuth();

  // Track when user creates multiple lists (sync opportunity)
  const shouldShowSyncPrompt = () => {
    if (isAuthenticated) return false;
    
    const lists = getUserLists();
    const totalWalks = Object.values(lists).reduce((acc, list) => acc + list.walks.length, 0);
    
    // Show if user has 5+ walks saved or 3+ lists
    return totalWalks >= 5 || Object.keys(lists).length >= 3;
  };

  // Track premium content access attempts
  const shouldShowPremiumPrompt = (walkId) => {
    // TODO: Check if walk is premium content
    // For now, simulate that walks with ID > 10 are premium
    return !isAuthenticated && parseInt(walkId) > 10;
  };

  // Track submission attempts
  const shouldShowSubmitPrompt = () => {
    return !isAuthenticated;
  };

  return {
    shouldShowSyncPrompt,
    shouldShowPremiumPrompt,
    shouldShowSubmitPrompt,
    isAuthenticated
  };
};

// Hook to handle conversion analytics
export const useConversionAnalytics = () => {
  const { isAuthenticated } = useAuth();

  const trackEvent = (eventName, properties = {}) => {
    // TODO: Send to analytics service (e.g., Mixpanel, Google Analytics)
    console.log('Conversion Event:', eventName, properties);
    
    // Examples of events to track:
    // - 'signup_prompt_shown'
    // - 'signup_completed'
    // - 'trial_started'
    // - 'premium_content_accessed'
    // - 'sync_prompt_dismissed'
  };

  return { trackEvent };
};

// Hook to handle conversion prompts and premium feature access
export const useConversion = () => {
  const { isAuthenticated, user } = useAuth();

  const showConversionPrompt = (feature) => {
    // Show different prompts based on the feature
    switch (feature) {
      case 'analytics':
        if (!isAuthenticated || user?.membership_tier === 'free') {
          // For now, just log - in production would show upgrade modal
          console.log('Analytics feature requires premium membership');
          return true;
        }
        break;
      case 'route_builder':
        if (!isAuthenticated || user?.membership_tier === 'free') {
          console.log('Route builder feature requires premium membership');
          return true;
        }
        break;
      case 'journals':
        if (!isAuthenticated || user?.membership_tier === 'free') {
          console.log('Journal feature requires premium membership');
          return true;
        }
        break;
      default:
        console.log('Premium feature accessed');
    }
    return false;
  };

  const isPremiumUser = () => {
    return isAuthenticated && user?.membership_tier !== 'free';
  };

  return {
    showConversionPrompt,
    isPremiumUser,
    isAuthenticated,
    user
  };
};